import React, { useState, useEffect } from "react";

const LoadImageApi = ({ closePopupHandler, id, url }) => {
  const [image, setImage] = useState("");

  useEffect(() => {
    const handleKeyEvent = (event) => {
      if (event.key === "Escape") {
        closePopupHandler();
      }
    };
    document.addEventListener("keydown", handleKeyEvent);
    return () => {
      document.removeEventListener("keydown", handleKeyEvent);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (id && url) {
        try {
          const fetchResponse = await fetch(
            `${process.env.REACT_APP_CRM}/live-chat/get-chat-image`,
            {
              method: "POST",
              body: JSON.stringify({ id, zoho_url: url }),
            }
          );

          if (fetchResponse.ok) {
            const dataResponse = await fetchResponse.json();
            if (dataResponse.code === 200) {
              const { data } = dataResponse;
              setImage(data.download_url);
            }
          } else {
            console.error("Fetch error: ", fetchResponse.statusText);
          }
        } catch (err) {
          console.error("Error: ", err);
        }
      }
    };

    fetchData();
  }, [id, url]);
  return (
    <div className="fixed-imageShow">
      <div className="image-show-body">
        <div className="close-image">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-6"
            width="30"
            onClick={closePopupHandler}
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </div>
        {image ? (
          <img src={image} style={{ maxWidth: "100%" }} />
        ) : (
          <img src="/loading.gif" className="myimage" />
        )}
      </div>
    </div>
  );
};

export default React.memo(LoadImageApi);



// WEBPACK FOOTER //
// ./src/components/chat/components/LoadImageApi.js